import type { PlanNamesType } from "../constants";
import { planNames } from "../constants";

export const plans: PlanType[] = [
  {
    name: planNames.STARTER,
    emoji: "🧬",
    price: 499,
    sessions: "75,000",
    setupFee: 300,
    rank: 1,
  },
  {
    name: planNames.PRO,
    emoji: "🚀",
    price: 699,
    sessions: "200,000",
    setupFee: 300,
    rank: 2,
  },
  {
    name: planNames.SCALE,
    emoji: "🔐",
    price: 1399,
    sessions: "400,000",
    setupFee: 300,
    rank: 3,
  },
  {
    name: planNames.ULTRA,
    emoji: "📈",
    price: 2799,
    sessions: "800,000",
    setupFee: 300,
    rank: 4,
  },
  // {
  //   name: planNames.APEX,
  //   emoji: "📈",
  //   price: 4199,
  //   sessions: "1,200,000",
  //   setupFee: 300,
  //   rank: 5,
  // },
  {
    name: planNames.TITAN,
    emoji: "📈",
    price: 5500,
    sessions: "1,600,000",
    setupFee: 300,
    rank: 6,
  },
];

export type PlanType = {
  name: PlanNamesType;
  emoji: string;
  price: number;
  sessions: string;
  setupFee: number;
  rank: number;
};

export const features = [
  "Unlimited stores",
  "Content protection from GMC bots, human moderators, VPNs, and search engines",
  "Done-for-you installation & setup",
  "Custom stealth rules for your offer",
  "Anti-theft protection (disables copy/paste & text selection)",
  "Account manager",
  "Upgrade or downgrade anytime",
];
